<template>
  <b-card-text>
    <div class="d-flex justify-content-between">
      <h5>АДРЕСА И БАНКОВСКИЕ РЕКВИЗИТЫ СТОРОН</h5>
      <b-button
        @click="predprosmotr = !predprosmotr"
      >
        Предпросмотр
      </b-button>
    </div>

    <div v-if="predprosmotr" class="predprosmotr-card">
      <p class="text-center font-weight-bold">10. ЮРИДИЧЕСКИЕ АДРЕСА И БАНКОВСКИЕ РЕКВИЗИТЫ СТОРОН.</p>
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <div>Экспедитор:</div>
          <div>ООО «ТАНАИС Брокер»</div>
          <div>Юридический адрес: 121552, г. Москва,</div>
          <div>вн.тер.г.муниципальный округ Кунцево,</div>
          <div>ш.Рублевское, д.101, кв.242</div>
          <div>Почтовый адрес: 119530, Москва, ОПС</div>
          <div>119530, а/я 5</div>
          <div>ОГРН 1167746200775</div>
          <div>ИНН 7731309397, КПП 773101001,</div>
          <div>Тел.: 8 (495) 785-04-93</div>
          <div>Реквизиты для оплаты:</div>
          <div>р/с 40702810677000009040</div>
		  <div>ф-л ПАО "Банк "Санкт-Петербург" в г.Москве</div>
		  <div>к/с 30101810045250000142</div>
		  <div>БИК 044525142</div>
          <div><br/></div>
          <div>Генеральный директор</div>
          <div>ООО «ТАНАИС Брокер»</div>
          <div><br/></div>
          <div><span style="text-decoration: underline">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</span>/Е.Э.Бородина/</div>
        </div>

        <div class="d-flex flex-column" style="max-width: 320px;">
          <div>Заказчик:</div>
          <div class="font-weight-bold">{{ docHistory['typ_dog_teo_exp'].short_pravovaya_form }} «{{ docHistory['typ_dog_teo_exp'].full_org_name }}»</div>
          <div>Юридический адрес: {{ docHistory['typ_dog_teo_exp'].ur_adress }}</div>
          <div>Почтовый адрес: {{ docHistory['typ_dog_teo_exp'].post_adress }}</div>
          <div>ИНН {{ docHistory['typ_dog_teo_exp'].inn_of_org }}, КПП {{ docHistory['typ_dog_teo_exp'].kpp_of_org }}</div>
          <div>ОГРН {{ docHistory['typ_dog_teo_exp'].ogrn_of_org }}</div>
          <div>р/с {{ docHistory['typ_dog_teo_exp'].ras_chet_of_org }}</div>
          <div>в {{ docHistory['typ_dog_teo_exp'].bank_of_org }}</div>
          <div>к/с {{ docHistory['typ_dog_teo_exp'].koresp_chet_of_org }}</div>
          <div>БИК {{ docHistory['typ_dog_teo_exp'].bik_of_org }}</div>
          <div>Тел.: {{ docHistory['typ_dog_teo_exp'].tel_of_org }}</div>
          <div><br/></div>
          <div>{{ docHistory['typ_dog_teo_exp'].in_face_imen_padej_of_org }}</div>
          <div>{{ docHistory['typ_dog_teo_exp'].short_pravovaya_form }} «{{ docHistory['typ_dog_teo_exp'].full_org_name }}»</div>
          <div><br/></div>
          <div><span style="text-decoration: underline">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</span>/{{ docHistory['typ_dog_teo_exp'].fio_of_face_short_of_org }}/</div>
        </div>
      </div>
    </div>

    <b-row class="my-2">
      <b-col cols="4">
        <label class="small-label">Сокращенная правовая форма:</label>
        <b-form-input
          :value="docHistory['typ_dog_teo_exp'].short_pravovaya_form"
          @input="docHistory['typ_dog_teo_exp'].short_pravovaya_form = $event.toUpperCase()"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="8">
        <label class="small-label">Наименование организации без признаков:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].full_org_name"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <label class="small-label">Юридический адрес:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].ur_adress"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col >
        <label class="small-label">Почтовый адрес:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].post_adress"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">ИНН:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].inn_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">КПП:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].kpp_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">ОГРН:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].ogrn_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">Телефон ((495) 000-00-00):</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].tel_of_org"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mt-4 mb-3 d-flex align-items-center" v-if="docHistory['companyDetails'].payment_details">
      <b-col cols="6">
        <label class="small-label font-weight-bold">Расчетные счета компании:</label>
      </b-col>
      <b-col cols="6">
        <b-form-select
          v-model="selectedPaymentType"
          @change="changePaymentDetails()"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- Выберите счет --</b-form-select-option>
          </template>
          <b-form-select-option 
            v-for="(item, index) in docHistory['companyDetails'].payment_details"
            :value="index"
            :key="item.id"
          >
            {{ item.bank_name }} - р/с: {{ item.payment_invoice }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">в банке (ПАО «Сбербанк»):</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].bank_of_org"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">р/с:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].ras_chet_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">к/с:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].koresp_chet_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">БИК банка:</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].bik_of_org"
          size="sm"
          type="number"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">Должность лица (именительный падеж):</label>
        <b-form-input
          :value="docHistory['typ_dog_teo_exp'].in_face_imen_padej_of_org"
          @input="docHistory['typ_dog_teo_exp'].in_face_imen_padej_of_org = capitalizeFirstLetter($event)"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">ФИО (И.О. Фамилия):</label>
        <b-form-input
          :value="docHistory['typ_dog_teo_exp'].fio_of_face_short_of_org"
          @input="docHistory['typ_dog_teo_exp'].fio_of_face_short_of_org = capitalizeFirstLetters($event)"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
  </b-card-text>
</template>

<script>
export default {
  data() {
    return {
      predprosmotr: false,
      selectedPaymentType: null
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    capitalizeFirstLetters(string) {
      return string.charAt(0).toUpperCase() + 
      string.charAt(1).toLowerCase() + 
      string.charAt(2).toUpperCase() + 
      string.charAt(3).toLowerCase() + 
      string.charAt(4).toUpperCase() + 
      string.slice(5).toLowerCase();
    },
    changePaymentDetails() {
      this.docHistory['typ_dog'].bank_of_org = this.docHistory['companyDetails'].payment_details[this.selectedPaymentType].bank_name;
      this.docHistory['typ_dog'].ras_chet_of_org = this.docHistory['companyDetails'].payment_details[this.selectedPaymentType].payment_invoice;
      this.docHistory['typ_dog'].koresp_chet_of_org = this.docHistory['companyDetails'].payment_details[this.selectedPaymentType].correspondent_invoice;
      this.docHistory['typ_dog'].bik_of_org = this.docHistory['companyDetails'].payment_details[this.selectedPaymentType].bic;
    }
  },
}
</script>

<style lang="scss" scoped>
  .small-label {
    font-size: 12px;
  }

  .predprosmotr-card {
    padding: 15px;
    margin: 20px 0;
    background: #cccccc59;
  }
</style>